import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/illustrations/email-signup.png")